/*
	Sometimes it's difficult to get a stable function reference to debounce and call in response to
	something like typed user input that you want to use to trigger API calls, e.g. for filtering
	a search, where you don't want to dispatch a call for every keystroke.

	Rather than debouncing an effect function, it may sometimes be easier to just debounce updating
	a piece of state, so effects are easier to write.

	Example usage:

	```
		function SearchBox(props){
			const dispatch = useDispatch();
			const [searchTerm, setSearchTerm] = useStateDebounced("");

			useEffect(() => {
				dispatch(search(searchTerm));
			}, [searchTerm])

			return (
				<Input
					// If the user types quickly, the `searchTerm` state will only update once
					// and the effect will only run once.
					onChange = {setSearchTerm}
				/>
			);
		}
	```
*/

import { useState } from "react";
import { debounce } from "lodash";
import { SEARCH_DEBOUNCE } from "utils/constants";

export default function useStateDebounced(initialValue, debounceTime = SEARCH_DEBOUNCE){
	const [state, setState] = useState(initialValue);
	const debouncedSetState = debounce(setState, debounceTime);

	return [state, debouncedSetState];
}
